import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { InputMask } from "primereact/inputmask";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import { useEffect, useState, useRef } from "react";
import CardSeplag from "../../../components/CardSeplag";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toolbar } from "primereact/toolbar";

import { initFormProvidencia, salvar, excluir } from "../../../service/Monitora/Lancamentos/providencias";
import { initFormRestricao } from "../../../service/Monitora/Lancamentos/restricoes";

import {
  getFormErrorMessage,
  printToast,
  summaryAlteracaoSucessoPadrao,
  detailAlteracaoSucessoPadrao,
  summaryCriacaoSucessoPadrao,
  detailCriacaoSucessoPadrao,
  detailExclusaoSucessoPadrao,
  summaryExclusaoSucessoPadrao,
  optSimNao,
} from "../../../config/global";

const Providencias = ({
  ptaMonitora,
  providencias,
  setProvidencias,
  setFormPta,
  isPodeEditar,
  opProvidencias,
  restricao,
  restricoes,
  setRestricoes,
}) => {
  const [formP, setFormP] = useState(initFormProvidencia);
  const [qtdMaxCaracteres, setQtdMaxCaracteres] = useState(2000);
  const [countCaracteres, setCountCaracteres] = useState(0);
  const [v_restricao, setVRestricao] = useState(initFormRestricao);
  const [displayForm, setDisplayForm] = useState("hidden");
  const [displayTable, setDisplayTable] = useState("block");

  useEffect(() => {
    contarCaracteres();
  }, []);

  const salvarProvidencia = () => {
    formP.restricao = restricao;
    let jsonPost = {
      ...formP,
    };

    let summary = formP.idenProvidencia > 0 ? summaryAlteracaoSucessoPadrao : summaryCriacaoSucessoPadrao;
    let detail = formP.idenProvidencia > 0 ? detailAlteracaoSucessoPadrao : detailCriacaoSucessoPadrao;

    salvar(jsonPost).then((res) => {
      /*let providencia = providencias.filter((item => item.idenProvidencia != res.idenProvidencia))

            setFormP(initFormProvidencia)
            setFormPta({...ptaMonitora, providencias:providencia})*/

      let v_providencia = providencias.filter((item) => item.idenProvidencia != res.idenProvidencia);
      v_providencia.push(res);
      let restricaoAtual = { ...restricao, providencias: v_providencia };
      let letRestricaoFilter = restricoes.filter((item) => item.idenRestricao != restricaoAtual.idenRestricao);
      let v_restricoes = letRestricaoFilter;
      v_restricoes.push(restricaoAtual);
      setProvidencias(v_providencia);
      setRestricoes(v_restricoes);
      setFormPta({ ...ptaMonitora, restricoes: v_restricoes });
      setFormP(initFormProvidencia);
      fecharFormProvidencia();

      printToast({ summary, detail });
    });
  };
  function editarProvidencia(rowData) {
    setFormP(rowData);
    setDisplayForm("block");
    setDisplayTable("hidden");
  }
  function excluirProvidencia(rowData) {
    excluir(rowData.idenProvidencia).then((res) => {
      let providenciasExc = providencias.filter((item) => item.idenProvidencia != rowData.idenProvidencia);
      let restricaoAtual = { ...restricao, providencias: providenciasExc };
      let letRestricaoFilter = restricoes.filter((item) => item.idenRestricao != restricaoAtual.idenRestricao);
      let v_restricoes = letRestricaoFilter;
      v_restricoes.push(restricaoAtual);
      setProvidencias(providenciasExc);
      setRestricoes(v_restricoes);
      setFormPta({ ...ptaMonitora, restricoes: v_restricoes });
      printToast({ summaryExclusaoSucessoPadrao, detailExclusaoSucessoPadrao });
    });
  }
  const rejectFunc = () => {};
  const confirmaExclusao = (rowData) => {
    confirmDialog({
      message: "Deseja excluir esta restrição?",
      header: "Confirmação",
      icon: "pi pi-exclamation-triangle",
      accept: () => excluirProvidencia(rowData),
      reject: () => rejectFunc(),
    });
  };
  const acoesTemplate = (node, column) => {
    return (
      <>
        <Button
          type="button"
          icon="pi pi-pencil"
          className="p-button-warning Raised"
          onClick={() => editarProvidencia(node)}
          disabled={!isPodeEditar || !ptaMonitora.permiteAndamento}
        ></Button>
        <Button
          type="button"
          icon="pi pi-trash"
          style={{ marginLeft: "5px" }}
          className="p-button-danger Raised"
          onClick={(e) => confirmaExclusao(node)}
          disabled={!isPodeEditar || !ptaMonitora.permiteRestricaoProvidencia}
        ></Button>
      </>
    );
  };
  function contarCaracteres() {
    setCountCaracteres(formP.descProvidencia != null ? qtdMaxCaracteres - formP.descProvidencia.length : 2000);
  }
  function abrirProvidencias(event, dados) {
    //setProvidencias(dados.providencias)
  }
  const leftToolbarTemplate = () => {
    return (
      <>
        <Button
          label="Nova Providência"
          icon="pi pi-plus"
          className="p-button-info mr-2"
          onClick={abrirFormProvidencia}
          disabled={!isPodeEditar || !ptaMonitora.permiteRestricaoProvidencia}
        />
      </>
    );
  };

  const RightToolbarTemplate = () => {
    return (
      <>
        <Button
          label="Fechar Painel de Providências"
          icon="pi pi-power-off"
          className="p-button-danger mr-2"
          onClick={fecharPainelProvidencia}
        />
        <Button
          label="Fechar Formulário"
          icon="pi pi-ban"
          className={displayForm + " p-button-warning mr-2"}
          onClick={fecharFormProvidencia}
        />
        <Button
          label="Salvar"
          icon="pi pi-save"
          className={displayForm + " p-button-success mr-2"}
          onClick={salvarProvidencia}
          disabled={!isPodeEditar || !ptaMonitora.permiteRestricaoProvidencia}
        />
      </>
    );
  };
  const abrirFormProvidencia = () => {
    setFormP(initFormProvidencia);
    setDisplayForm("block");
    setDisplayTable("hidden");
  };
  const fecharFormProvidencia = () => {
    setDisplayForm("hidden");
    setDisplayTable("block");
  };

  const fecharPainelProvidencia = () => {
    opProvidencias.current.hide();
  };

  return (
    <>
      <CardSeplag
        title={
          "Providências da Restrição " + restricao.tipoRestricao.nomeTipoRestricao + " de " + restricao.dataRestricao
        }
        class="card"
      >
        <div className={displayForm + " formgrid grid "}>
          <div className="field col-2">
            <span>
              <label htmlFor="dataprovidencia">Data</label>
              <InputMask
                mask="99/99/9999"
                slotChar="__/__/____"
                placeholder="__/__/____"
                id="dataprovidencia"
                class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                value={formP.dataProvidencia}
                onChange={(e) => setFormP({ ...formP, dataProvidencia: e.target.value })}
                disabled={!isPodeEditar || !ptaMonitora.permiteRestricaoProvidencia}
              />
            </span>
          </div>
          <div className="field col-12">
            <span>
              <label htmlFor="descprovidencia">Descrição</label>
              <InputTextarea
                id="descprovidencia"
                maxLength={2000}
                rows={7}
                cols={110}
                class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                value={formP.descProvidencia}
                onKeyUp={(e) => setCountCaracteres(qtdMaxCaracteres - e.target.value.length)}
                onChange={(e) => setFormP({ ...formP, descProvidencia: e.target.value })}
                disabled={!isPodeEditar || !ptaMonitora.permiteRestricaoProvidencia}
              />
            </span>
          </div>
          <div className="field col-12">
            <span>
              <b>{countCaracteres}</b> caractere(s) restante(s)
            </span>
          </div>

          {/*<div className="col-12">
                        <div className=" grid">
                            <div className="field col-8"></div>
                            <div className="field col-2">
                                <Button label="Salvar" icon="pi pi-save" className="p-button-success mr-2" onClick={abrirFormProvidencia} />
                            </div>
                            <div className="field col-2">
                                <Button label="Fechar" icon="pi pi-save" className="p-button-warning mr-2" onClick={fecharFormProvidencia} />
                            </div>
                        </div>
                    </div> */}
        </div>
        <Toolbar className=" mb-4" left={leftToolbarTemplate} right={RightToolbarTemplate}></Toolbar>
        <DataTable
          value={providencias}
          selectionMode="single"
          className={displayTable}
          paginator
          rows={5}
          emptyMessage="Não foram encontradas providências"
        >
          <Column
            body={acoesTemplate}
            style={{ textAlign: "center", width: "12%" }}
            field="idenProvidencia"
            header="Ações"
          ></Column>
          <Column field="dataProvidencia" header="Data" />
          <Column field="descProvidencia" header="Descrição da providência" />
        </DataTable>
      </CardSeplag>
    </>
  );
};

export default Providencias;
